import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';
import Dollar from '../../../assets/emojis/dollar/dollar@3x.png'
import CurrencyInput from 'react-currency-input';

export default class BairroModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.idBairro,
            letra: props.letraBairro,
            valorClass: 'div-input',
            valor: props.valorBairro
        }
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'valor':
                var valor = event.target.value;
                var formatValue = valor.split(' ');
                var formated = formatValue[1]?.replace(/,/g, '.');
                this.setState({
                    valor: Number(formated).toFixed(2)
                });
                break;
            default:
                break;
        }
    }

    render() {
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <div className="header">
                    <img alt="" className="emoji" src={Dollar} />
                    <h1>Adicione o valor da taxa de entrega</h1>
                </div>

                <div className="input-valor">
                    <div className={this.state.valorClass}>
                            <CurrencyInput
                                inputType="text"
                                maxLength="9"
                                name="valor"
                                prefix="R$ "
                                onFocus={() => {
                                    this.setState({
                                        valorClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        valorClass: 'div-input'
                                    })
                                }}
                                required
                                decimalSeparator=","
                                value={this.state.valor}
                                onChangeEvent={(e) => this.handleInputs(e)}
                            />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite um valor</span>
                            </label>
                    </div>
                </div>

                <div className="botao">
                    <button 
                        onClick={() => this.props.salvar(this.state.id, this.state.letra, this.state.valor)}
                        className="salvar">Salvar alterações</button>
                </div>
            </Container>
        )
    }
}